// Brand feature flags with safe defaults.
//
// Only white-label brand configs (e.g. trainingcamp) export IS_WHITE_LABEL / DEFAULT_THEME_MODE;
// the LearnZapp brands (isc2, isaca, pmp, …) don't. Under CRA 5's `strictExportPresence`, a STATIC
// reference to a missing export — whether a named import (`import { IS_WHITE_LABEL }`) OR a static
// namespace member (`ns.IS_WHITE_LABEL`) — is a HARD compile error. So we read the values via a
// DYNAMIC key (`ns[variable]`), which webpack can't statically resolve and therefore can't flag,
// and fall back to a default. This is the single place shared code reads these flags.
import * as appConstant from "../../app_constant";

function flag(key, fallback) {
  const value = appConstant[key];
  return value === undefined ? fallback : value;
}

export const IS_WHITE_LABEL = flag("IS_WHITE_LABEL", false);
export const DEFAULT_THEME_MODE = flag("DEFAULT_THEME_MODE", "dark");
// Brand key for the @learnzapp/core theme palette registry. Only brands with a
// custom palette set it (e.g. trainingcamp); everyone else falls back to
// 'default' → the canonical LearnZapp scheme.
export const BRAND_THEME = flag("BRAND_THEME", "default");
